module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs-poster"
  }, [(_vm.$teras.evento.poster == 1) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": _vm.$teras.lang.datiabsPoster,
      "prop": "poster"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.poster),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "poster", $$v)
      },
      expression: "$abs.row.poster"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (((_vm.$teras.evento.poster == 1 && _vm.$abs.row.poster == 1) || _vm.$teras.evento.poster == 2) && _vm.$teras.topicposter.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Topic",
      "prop": "topicposter"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$teras.lang.scegliere_lista
    },
    model: {
      value: (_vm.$abs.row.topicposter),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "topicposter", $$v)
      },
      expression: "$abs.row.topicposter"
    }
  }, _vm._l((_vm.$teras.topicposter), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nome,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.id == 136 && _vm.$abs.row.poster == 1) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Partecipi al Premio della Fondazione?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.comunicazione == 1) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": _vm.$teras.lang.datiabsOrale,
      "prop": "comunicazione"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.comunicazione),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "comunicazione", $$v)
      },
      expression: "$abs.row.comunicazione"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (((_vm.$teras.evento.comunicazione == 1 && _vm.$abs.row.comunicazione == 1) || _vm.$teras.evento.comunicazione == 2) && _vm.$teras.topiccomunicazione.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Topic",
      "prop": "topiccomunicazione"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.topiccomunicazione),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "topiccomunicazione", $$v)
      },
      expression: "$abs.row.topiccomunicazione"
    }
  }, _vm._l((_vm.$teras.topiccomunicazione), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nome,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.poster == 3 && _vm.$abs.row.comunicazione == '0') ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": _vm.$teras.lang.datiabsPoster,
      "prop": "poster"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.poster),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "poster", $$v)
      },
      expression: "$abs.row.poster"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.poster == 3 && _vm.$abs.row.poster == 1 && _vm.$abs.row.comunicazione == '0' && _vm.$teras.topicposter.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Topic",
      "prop": "topicposter"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$teras.lang.scegliere_lista
    },
    model: {
      value: (_vm.$abs.row.topicposter),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "topicposter", $$v)
      },
      expression: "$abs.row.topicposter"
    }
  }, _vm._l((_vm.$teras.topicposter), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nome,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.posterdopocomunicazione == 1 && _vm.$abs.row.comunicazione == 1) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": _vm.$teras.lang.datiabsPosterNoOrale,
      "prop": "posterdopocomunicazione"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.poster),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "poster", $$v)
      },
      expression: "$abs.row.poster"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.posterdopocomunicazione == 1 && _vm.$abs.row.comunicazione == 1 && _vm.$abs.row.poster == 1 && _vm.$teras.topicposter.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Topic ",
      "prop": "topicposter"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$teras.lang.scegliere_lista
    },
    model: {
      value: (_vm.$abs.row.topicposter),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "topicposter", $$v)
      },
      expression: "$abs.row.topicposter"
    }
  }, _vm._l((_vm.$teras.topicposter), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nome,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.topicposter == 11 && _vm.$abs.row.comunicazione == 0) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Desidera partecipare all'assegnazione del premio Binding Site?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 41 && _vm.$abs.row.comunicazione == 0) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Desidera partecipare all'assegnazione del premio Binding Site?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 84) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 98) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD - SECONDA EDIZIONE?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 131) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD - TERZA EDIZIONE?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 149) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD - QUARTA EDIZIONE?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 172) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD - QUINTA EDIZIONE?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 177) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Desideri partecipare all'assegnazione dei Premi?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.id == 14) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Desidera concorrere ai premi previsti per il congresso?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78124610"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Abs-poster.vue
// module id = 613
// module chunks = 2